// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__0ZACs","shimmer":"Skeleton_shimmer__AQStX","wrapper":"Skeleton_wrapper__GGm7R"};